import { useEffect, useState } from "react";
import fallback_img from "./img/fallback_img.jpg"

import loading_img from "./img/loadingImg.jpg"

import { AudioWaveform, Blocks, ChevronDown, ChevronLeft, DownloadCloud, Fan, File, Flag, FolderCheck, Grid3X3, Heart, Info, LibraryBig, MessageCircle, Pencil, ShoppingCart, SquareDashedMousePointer, Video } from "lucide-react";
import CoursePageCardSubCourse from "../CoursePageDesign/CoursePageCardSubCourse";
import { coursePageObject } from "../CoursePageDesign/ExportCoursePageObject";

const PlayerSideBar =({setShowLeftQueBar,playerCard1Object,progress=20})=>{
      const showProgress = typeof progress === 'number' && progress >= 0 && progress <= 100;

      
  const [toggleState , setToggleState] =useState(false)
  const [theme , setTheme] =useState("")
    const ImageFallFB = ({ itemOuter,boxShadow,src,width,aspectRatio, borderRadius,border,paddingLeft,paddingRight}) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [hasError, setHasError] = useState(false);
  
     
          const [reloadItems, setReloadItems] = useState(true);
         
             useEffect(()=>{
                 setReloadItems(false); setReloadItems(true);
                 
             },[ ])

               
  return (
    <div style={{ position: "relative",boxShadow:boxShadow,
    overflow: "hidden",aspectRatio: aspectRatio,padding:"0px",border:border, 
     borderTopLeftRadius:`${borderRadius?.topLeft?.value}${borderRadius?.topLeft?.resolution}`,
              borderTopRightRadius:`${borderRadius?.topRight?.value}${borderRadius?.topRight?.resolution}`,
              borderBottomLeftRadius:`${borderRadius?.bottomLeft?.value}${borderRadius?.bottomLeft?.resolution}`,
              borderBottomRightRadius:`${borderRadius?.bottomRight?.value}${borderRadius?.bottomRight?.resolution}`,
              
    width:`${width}%`}}  className={`Theme1InfoCard1-CardImage-AspectRatioXs${itemOuter?.myKey}`}>
      {!isLoaded && !hasError && (
        <div
         style={
             { 
              borderTopLeftRadius:`${borderRadius?.topLeft?.value}${borderRadius?.topLeft?.resolution}`,
              borderTopRightRadius:`${borderRadius?.topRight?.value}${borderRadius?.topRight?.resolution}`,
              borderBottomLeftRadius:`${borderRadius?.bottomLeft?.value}${borderRadius?.bottomLeft?.resolution}`,
              borderBottomRightRadius:`${borderRadius?.bottomRight?.value}${borderRadius?.bottomRight?.resolution}`,
                position: "absolute",
      top: 0,
      left: 0,
      width: `${width}%`,
      aspectRatio: aspectRatio,
      objectFit: "cover",  }}
       className={`Theme1InfoCard1-CardImage-AspectRatioXs${itemOuter?.myKey}`}
        >
          <img
        src={loading_img}
        alt=""
      
       style={
             {
             borderTopLeftRadius:`${borderRadius?.topLeft?.value}${borderRadius?.topLeft?.resolution}`,
              borderTopRightRadius:`${borderRadius?.topRight?.value}${borderRadius?.topRight?.resolution}`,
              borderBottomLeftRadius:`${borderRadius?.bottomLeft?.value}${borderRadius?.bottomLeft?.resolution}`,
              borderBottomRightRadius:`${borderRadius?.bottomRight?.value}${borderRadius?.bottomRight?.resolution}`,
              
                position: "absolute",border:border,
      top: 0,
      left: 0,
      width: `${width}%`,padding:"10px",
    
      objectFit: "cover", aspectRatio: aspectRatio,  }}
       className={`Theme1InfoCard1-CardImage-AspectRatioXs${itemOuter?.myKey}`}
      />
        </div>
      )}
      
      <img

      
        src={hasError ? fallback_img : src}
        alt=""
        onLoad={() => setIsLoaded(true)}
        onError={() => setHasError(true)}
       style={
             {
                position: "absolute",
      top: 0,
      left: 0,
      width: `${width}%`,
     
      objectFit: "cover",aspectRatio: aspectRatio  }}
       className={`Theme1InfoCard1-CardImage-AspectRatioXs${itemOuter?.myKey}`}
      />
    
    </div>
  );
};
    return(<>
    <div className="sidebarCardOuter">
      
 <div className="sidebarCardSection">
    
<div className="sidebarCardSectionInner" style={{background:`${playerCard1Object?.milestone?.bgColor?.color}`,
border:` ${playerCard1Object?.milestone?.border?.borderWidth?.value+playerCard1Object?.milestone?.border?.borderWidth?.resolution} ${playerCard1Object?.milestone?.border?.borderType}  ${playerCard1Object?.milestone?.border?.borderColor?.color}`,
 borderTopLeftRadius:`${playerCard1Object?.milestone?.borderRadius?.topLeft?.value}${playerCard1Object?.milestone?.borderRadius?.topLeft?.resolution}`,
              borderTopRightRadius:`${playerCard1Object?.milestone?.borderRadius?.topRight?.value}${playerCard1Object?.milestone?.borderRadius?.topRight?.resolution}`,
              borderBottomLeftRadius:`${playerCard1Object?.milestone?.borderRadius?.bottomLeft?.value}${playerCard1Object?.milestone?.borderRadius?.bottomLeft?.resolution}`,
              borderBottomRightRadius:`${playerCard1Object?.milestone?.borderRadius?.bottomRight?.value}${playerCard1Object?.milestone?.borderRadius?.bottomRight?.resolution}`,
              marginBottom:"2px"}}>
    <div >
    <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",gap:"5px"}}>
        <Fan size={16} color={playerCard1Object?.milestone?.textColor?.color} />
    <div className="player-cardTitleFont"  style={{fontSize:"12px",fontWeight:"800",margin:"0px",width:"65px",color:`${playerCard1Object?.milestone?.textColor?.color}`}}>{playerCard1Object?.milestone?.title}</div>&bull;
 <div className="player-cardTitleFont playerSidebarEllipsis"  style={{fontSize:"12px",fontWeight:"800",margin:"0px",width:"70px",color:`${playerCard1Object?.milestone?.textColor?.color}`}}>Sub Course 1 </div> 
<button  className="player-card__wishlist" style={{background:`${playerCard1Object?.milestone?.iconBgColor?.color}`,border:"0px",width:"40px",padding:"5px 3px"}} onClick={() => {}}>
   <span className='player-cardButtonFont' style={{fontSize:"9px",color:`${playerCard1Object?.milestone?.iconColor?.color}`}}> Change</span></button>

    </div><div style={{display:"flex",justifyContent:"left",alignItems:"center",gap:"5px"}}>
    
    <span  className="player-cardTagsFont" style={{fontSize:"10px",color:`${playerCard1Object?.milestone?.textColor?.color}`}}>3 Sections</span><span  className="player-cardTagsFont" style={{fontSize:"10px",color:`${playerCard1Object?.milestone?.textColor?.color}`}}>&bull; 7 Chapters</span>
    </div>    </div>
    <div style={{background:`${playerCard1Object?.milestone?.iconBgColor?.color}`,width:"30px",height:"30px",borderRadius:"50%",
                  display:"flex",justifyContent:"center",alignItems:"center",   alignContent:"center",margin:"10px",cursor:"pointer"}} onClick={()=>{}} ><ChevronDown size={22}  color={playerCard1Object?.milestone?.iconColor?.color}/></div> 


</div> 
<div className="sidebarCardSectionInner" style={{background:`${playerCard1Object?.section?.bgColor?.color}`,
border:` ${playerCard1Object?.section?.border?.borderWidth?.value+playerCard1Object?.section?.border?.borderWidth?.resolution} ${playerCard1Object?.section?.border?.borderType}  ${playerCard1Object?.section?.border?.borderColor?.color}`,
 borderTopLeftRadius:`${playerCard1Object?.section?.borderRadius?.topLeft?.value}${playerCard1Object?.section?.borderRadius?.topLeft?.resolution}`,
              borderTopRightRadius:`${playerCard1Object?.section?.borderRadius?.topRight?.value}${playerCard1Object?.section?.borderRadius?.topRight?.resolution}`,
              borderBottomLeftRadius:`${playerCard1Object?.section?.borderRadius?.bottomLeft?.value}${playerCard1Object?.section?.borderRadius?.bottomLeft?.resolution}`,
              borderBottomRightRadius:`${playerCard1Object?.section?.borderRadius?.bottomRight?.value}${playerCard1Object?.section?.borderRadius?.bottomRight?.resolution}`,
              marginBottom:"2px"}}>
    <div >
    <div style={{display:"flex",justifyContent:"left",alignItems:"center",gap:"5px"}}>
        <Blocks size={26} color={playerCard1Object?.section?.textColor?.color} />
    <div className="player-cardTitleFont"  style={{fontSize:"16px",fontWeight:"800",margin:"0px",color:`${playerCard1Object?.section?.textColor?.color}`}}>{playerCard1Object?.section?.title} </div>

    </div><div style={{display:"flex",justifyContent:"left",alignItems:"center",gap:"5px"}}>
    
    <span  className="player-cardTagsFont"  style={{fontSize:"10px",color:`${playerCard1Object?.section?.textColor?.color}`}}>3 Chapters</span><span  className="player-cardTagsFont" style={{fontSize:"10px",color:`${playerCard1Object?.section?.textColor?.color}`}}>&bull; 7 Lectures</span><span  className="player-cardTagsFont"  style={{fontSize:"10px",color:`${playerCard1Object?.section?.textColor?.color}`}}>&bull; 9 Quizzes</span><span  className="player-cardTagsFont"  style={{fontSize:"10px",color:`${playerCard1Object?.section?.textColor?.color}`}}>  &bull; 3 PDFs</span>
    </div>    </div>
    <div style={{background:`${playerCard1Object?.section?.iconBgColor?.color}`,width:"30px",height:"30px",borderRadius:"50%",
                  display:"flex",justifyContent:"center",alignItems:"center",   alignContent:"center",margin:"10px",cursor:"pointer"}} onClick={()=>{}} ><ChevronDown size={22}  color={playerCard1Object?.section?.iconColor?.color}/></div> 


</div>

 <div className="sidebarCardChapter">
    <div className="sidebarCardSectionInner" style={{background:`${playerCard1Object?.chapter?.bgColor?.color}`,
border:` ${playerCard1Object?.chapter?.border?.borderWidth?.value+playerCard1Object?.chapter?.border?.borderWidth?.resolution} ${playerCard1Object?.chapter?.border?.borderType}  ${playerCard1Object?.chapter?.border?.borderColor?.color}`,
 borderTopLeftRadius:`${playerCard1Object?.chapter?.borderRadius?.topLeft?.value}${playerCard1Object?.chapter?.borderRadius?.topLeft?.resolution}`,
              borderTopRightRadius:`${playerCard1Object?.chapter?.borderRadius?.topRight?.value}${playerCard1Object?.chapter?.borderRadius?.topRight?.resolution}`,
              borderBottomLeftRadius:`${playerCard1Object?.chapter?.borderRadius?.bottomLeft?.value}${playerCard1Object?.chapter?.borderRadius?.bottomLeft?.resolution}`,
              borderBottomRightRadius:`${playerCard1Object?.chapter?.borderRadius?.bottomRight?.value}${playerCard1Object?.chapter?.borderRadius?.bottomRight?.resolution}`,
              marginBottom:"2px"}}><div>
    <div style={{display:"flex",justifyContent:"left",alignItems:"center",gap:"5px"}}>
    <AudioWaveform size={26} color={playerCard1Object?.chapter?.textColor?.color} />
    <div className="player-cardTitleFont" style={{fontSize:"14px",fontWeight:"800",margin:"0px",color:`${playerCard1Object?.chapter?.textColor?.color}`}}>{playerCard1Object?.chapter?.title}</div>
    </div><div style={{display:"flex",justifyContent:"left",alignItems:"center",gap:"5px"}}>
    
    <span className="player-cardTagsFont" style={{fontSize:"10px",color:`${playerCard1Object?.chapter?.textColor?.color}`}}>2 Lectures</span><span  className="player-cardTagsFont"  style={{fontSize:"10px",color:`${playerCard1Object?.chapter?.textColor?.color}`}}>&bull; 3 Quizzes</span><span  className="player-cardTagsFont"  style={{fontSize:"10px",color:`${playerCard1Object?.chapter?.textColor?.color}`}}> &bull; 1 PDF</span>
    </div> 
    </div>
    <div style={{background:`${playerCard1Object?.chapter?.iconBgColor?.color}`,width:"30px",height:"30px",borderRadius:"50%",
                  display:"flex",justifyContent:"center",alignItems:"center",   alignContent:"center",margin:"10px",cursor:"pointer"}} onClick={()=>{}} ><ChevronDown size={22}  color={playerCard1Object?.chapter?.iconColor?.color}/></div> 


</div>
    <div className="sidebarLessonCardOuter" style={{background:`${playerCard1Object?.lessonCard?.bgColor?.color}`,
border:` ${playerCard1Object?.lessonCard?.border?.borderWidth?.value+playerCard1Object?.lessonCard?.border?.borderWidth?.resolution} ${playerCard1Object?.lessonCard?.border?.borderType}  ${playerCard1Object?.lessonCard?.border?.borderColor?.color}`,
 borderTopLeftRadius:`${playerCard1Object?.lessonCard?.borderRadius?.topLeft?.value}${playerCard1Object?.lessonCard?.borderRadius?.topLeft?.resolution}`,
              borderTopRightRadius:`${playerCard1Object?.lessonCard?.borderRadius?.topRight?.value}${playerCard1Object?.lessonCard?.borderRadius?.topRight?.resolution}`,
              borderBottomLeftRadius:`${playerCard1Object?.lessonCard?.borderRadius?.bottomLeft?.value}${playerCard1Object?.lessonCard?.borderRadius?.bottomLeft?.resolution}`,
              borderBottomRightRadius:`${playerCard1Object?.lessonCard?.borderRadius?.bottomRight?.value}${playerCard1Object?.lessonCard?.borderRadius?.bottomRight?.resolution}`,
              marginBottom:"2px"}}>
<div className="sidebarlessonCard">
  {playerCard1Object?.lessonCard?.lessonCardTheme=="T1"?
<div className="sidebarlessonInnerSectionThemeTwo"  >
    <div className="">
    <div className="sidebarCardLessonInner">
    <div style={{display:"flex",justifyContent:"left",alignItems:"center",gap:"5px"}}>
    <Video size={26} color={playerCard1Object?.lessonCard?.textColor?.color} />
    <div className="player-cardHeaderFont" style={{fontSize:"16px",fontWeight:"800",margin:"0px",color:`${playerCard1Object?.lessonCard?.textColor?.color}`}}>{playerCard1Object?.lessonCard?.title1}</div>
    </div>
    <div style={{background:`${playerCard1Object?.lessonCard?.iconBgColor?.color}`,width:"30px",height:"30px",borderRadius:"50%",
                  display:"flex",justifyContent:"center",alignItems:"center",   alignContent:"center",margin:"10px",cursor:"pointer"}} onClick={()=>{}} ><Info size={22}  color={playerCard1Object?.lessonCard?.iconColor?.color}/></div> 


</div> <ImageFallFB  boxShadow={``}
                  src={playerCard1Object?.lessonCard?.imageThumbnail?.src}
                  border={playerCard1Object?.lessonCard?.imageThumbnail?.border?.borderWidth?.value+playerCard1Object?.lessonCard?.imageThumbnail?.border?.borderWidth?.resolution+" "+playerCard1Object?.lessonCard?.imageThumbnail?.border?.borderType +" "+playerCard1Object?.lessonCard?.imageThumbnail?.border?.borderColor?.color}
                  width={ 100
                  }
                  aspectRatio={playerCard1Object?.lessonCard?.imageThumbnail?.aspectRatio?.value}
                  borderRadius={ playerCard1Object?.lessonCard?.imageThumbnail?.borderRadius
                  }/>
         {showProgress && (
<div className="player-card__progress">
<div className="player-card__progress-row">
<span className="player-cardSubTitleFont"style={{color:`${playerCard1Object?.lessonCard?.textColor?.color}`}}>Progress</span>
<span style={{color:`${playerCard1Object?.lessonCard?.textColor?.color}`}}>{progress}%</span>
</div>
<div className="player-card__progress-bar">
<div className="player-card__progress-fill" style={{ width: `${progress}%` }} />
</div>
</div>
)}           
</div>  
 <div className="sidebarlessonTitleSection" ><div style={{width:"100%"}}>
    
   <h3 className="player-cardTitleFont"  style={{margin:"0px",paddingTop:"0px",marginTop:"-5px",color:`${playerCard1Object?.lessonCard?.textColor?.color}`}}> kaushal is a good coder , he loves coding</h3>
   <p className="playerSidebarEllipsis player-cardSubTitleFont"style={{margin:"0px",paddingTop:"0px",fontSize:"11px",color:`${playerCard1Object?.lessonCard?.textColor?.color}`}}> kaushal is a good coder , he loves coding, he loves coding</p>
   </div>
</div>
</div>:playerCard1Object?.lessonCard?.lessonCardTheme=="T2"?<div className="sidebarlessonInnerSection" >
    <div className="sidebarlessoImage">
   
  <ImageFallFB  boxShadow={``}
                  src={playerCard1Object?.lessonCard?.imageThumbnail?.src}
                  border={playerCard1Object?.lessonCard?.imageThumbnail?.border?.borderWidth?.value+playerCard1Object?.lessonCard?.imageThumbnail?.border?.borderWidth?.resolution+" "+playerCard1Object?.lessonCard?.imageThumbnail?.border?.borderType +" "+playerCard1Object?.lessonCard?.imageThumbnail?.border?.borderColor?.color}
                  width={ 100
                  }
                  aspectRatio={playerCard1Object?.lessonCard?.imageThumbnail?.aspectRatio?.value}
                  borderRadius={ playerCard1Object?.lessonCard?.imageThumbnail?.borderRadius
                  }/>
         {showProgress && (
<div className="player-card__progress">
<div className="player-card__progress-row">
<span className="player-cardSubTitleFont"style={{color:`${playerCard1Object?.lessonCard?.textColor?.color}`}}>Progress</span>
<span style={{color:`${playerCard1Object?.lessonCard?.textColor?.color}`}}>{progress}%</span>
</div>
<div className="player-card__progress-bar">
<div className="player-card__progress-fill" style={{ width: `${progress}%` }} />
</div>
</div>
)}           
</div>  
 <div className="sidebarlessonTitleSection" ><div style={{width:"100%"}}>
     <div className="sidebarCardLessonInner">
    <div style={{display:"flex",justifyContent:"left",alignItems:"center",gap:"5px"}}>
    <Video size={26} color={playerCard1Object?.lessonCard?.textColor?.color} />
    <div className="player-cardHeaderFont"  style={{fontSize:"16px",fontWeight:"800",margin:"0px",color:`${playerCard1Object?.lessonCard?.textColor?.color}`}}>{playerCard1Object?.lessonCard?.title1}</div>
    </div>
    <div style={{background:`${playerCard1Object?.lessonCard?.iconBgColor?.color}`,width:"30px",height:"30px",borderRadius:"50%",
                  display:"flex",justifyContent:"center",alignItems:"center",   alignContent:"center",margin:"10px",cursor:"pointer"}} onClick={()=>{}} ><Info size={22}  color={playerCard1Object?.lessonCard?.iconColor?.color}/></div> 


</div>
   <h3 className="player-cardTitleFont " style={{margin:"0px",paddingTop:"0px",marginTop:"-5px",color:`${playerCard1Object?.lessonCard?.textColor?.color}`}}> kaushal is a good coder , he loves coding</h3>
   <p className="playerSidebarEllipsis player-cardSubTitleFont"style={{margin:"0px",paddingTop:"0px",fontSize:"11px",color:`${playerCard1Object?.lessonCard?.textColor?.color}`}}> kaushal is a good coder , he loves coding, he loves coding</p>
   </div>
</div>
</div>:""}

</div>

<div >
     <div className="sidebarlessonInnerSection" style={{position:"relative",display:"flex",justifyContent:"space-between",padding:"10px",
     borderRadius:"10px",marginTop:"10px",width:"95%",marginBottom:"10px",
                      background:`${playerCard1Object?.lessonCard?.toggeleCardBgColor?.color}`}}>
              <div className="player-cardSubTitleFont">{playerCard1Object?.lessonCard?.title2}</div>
 
        <span  className=""  style={{marginTop:"-8px"}}>
       
        <label   class="player-switchmutesmall "> 
 <input id="togglemute" checked={toggleState} onChange={e=>setToggleState(e.target.checked)}   type="checkbox"  
    /> 
   
  <span class="player-cardlfmutesmall round"></span>
</label>
    
    </span>
  </div>
  {/* <div style={{display:"flex",padding:"5px",justifyContent:"space-between",gap:"7px",background:`${playerCard1Object?.lessonCardButtons?.bgColor?.color}`,
border:` ${playerCard1Object?.lessonCardButtons?.border?.borderWidth?.value+playerCard1Object?.lessonCardButtons?.border?.borderWidth?.resolution} ${playerCard1Object?.lessonCardButtons?.border?.borderType}  ${playerCard1Object?.lessonCardButtons?.border?.borderColor?.color}`,
 borderTopLeftRadius:`${playerCard1Object?.lessonCardButtons?.borderRadius?.topLeft?.value}${playerCard1Object?.lessonCardButtons?.borderRadius?.topLeft?.resolution}`,
              borderTopRightRadius:`${playerCard1Object?.lessonCardButtons?.borderRadius?.topRight?.value}${playerCard1Object?.lessonCardButtons?.borderRadius?.topRight?.resolution}`,
              borderBottomLeftRadius:`${playerCard1Object?.lessonCardButtons?.borderRadius?.bottomLeft?.value}${playerCard1Object?.lessonCardButtons?.borderRadius?.bottomLeft?.resolution}`,
              borderBottomRightRadius:`${playerCard1Object?.lessonCardButtons?.borderRadius?.bottomRight?.value}${playerCard1Object?.lessonCardButtons?.borderRadius?.bottomRight?.resolution}`,
              }}>
    <div style={{display:"flex",justifyContent:"space-between",gap:"7px"}}>
<button className="player-card__cart" style={{padding:"5px 3px"}} 
onClick={() => {}}><MessageCircle size={16} color={playerCard1Object?.lessonCardButtons?.iconColor?.color?playerCard1Object?.lessonCardButtons?.iconColor?.color:"#444444"} />
<span className='player-cardButtonFont' style={{fontSize:"10px"}}>{playerCard1Object?.lessonCardButtons?.title1}</span></button>
<button className="player-card__wishlist" style={{padding:"5px 4px"}} onClick={() => {}}><Flag size={16} color={playerCard1Object?.lessonCardButtons?.iconColor?.color?playerCard1Object?.lessonCardButtons?.iconColor?.color:"#444444"} />
<span className='player-cardButtonFont' style={{fontSize:"10px"}}>{playerCard1Object?.lessonCardButtons?.title2}</span></button>
</div> <div style={{display:"flex",justifyContent:"space-between",gap:"7px"}}><button className="player-card__wishlist" style={{padding:"5px 4px"}} onClick={() => {}}><Pencil size={16} color={playerCard1Object?.lessonCardButtons?.iconColor?.color?playerCard1Object?.lessonCardButtons?.iconColor?.color:"#444444"} />
<span className='player-cardButtonFont' style={{fontSize:"10px"}}>{playerCard1Object?.lessonCardButtons?.title3}</span></button>
<button className="player-card__wishlist" style={{padding:"5px 3px"}} onClick={() => {}}><DownloadCloud size={16} color={playerCard1Object?.lessonCardButtons?.iconColor?.color?playerCard1Object?.lessonCardButtons?.iconColor?.color:"#444444"} />
<span className='player-cardButtonFont' style={{fontSize:"10px"}}> {playerCard1Object?.lessonCardButtons?.title4}</span></button>
</div>
</div>      */}
</div>
    </div>
   </div>

    </div></div>


     <style>{`



     .playerSidebarEllipsis{
     position:relative;
     
        white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    }
    .sidebarLessonCardOuter{
    padding:10px;
    }
   
   .sidebarCardSectionInner{
    gap:10px;padding:5px; position:relative;
    display:flex;min-width:180px;
    justify-content:space-between;
    }.sidebarCardLessonInner{
    gap:10px; position:relative;margin-top:-20px;
    display:flex;min-width:180px;width:100%;
    justify-content:space-between;
    }

   
   
    .sidebarlessonCard{
    display:flex;
    justify-content:space-between;
    align-items:left;gap:10px;
    
    }
    .sidebarlessoImage{width:100px;}
    .sidebarlessonTitleSection,.sidebarlessonInnerSection{
    gap:10px;padding:5px; position:relative;
    display:flex;min-width:180px;width:100%;
    justify-content:left;
    align-items:left;}
.sidebarlessonInnerSectionThemeTwo{width:100%;}
.player-switchmutesmall {
    position: relative;padding:5px;padding-left:0px;
    display: inline-block;
    width: 77px;
    transform: scale(0.4);
    height: 25px;
    margin: 2px;
  }
  
  .player-switchmutesmall input {display:none;}
  
  .player-cardlfmutesmall {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color:${playerCard1Object?.lessonCard?.toggleColor?.color};box-shadow:0 7px 20px 0 rgba(144, 202, 249,0.3);
    -webkit-transition: .4s;
    transition: .4s;
  }
  .player-cardlfmutesmall:before {
    position: absolute;
    content: "";
    height: 30px;
    width: 30px;
    left: 0px;
    bottom: -4px;
    background: ${playerCard1Object?.lessonCard?.toggleColor?.color};box-shadow:0 7px 20px 0 rgba(144, 202, 249,0.03);;border:7px solid #f9f9f9;
    -webkit-transition: .4s;
    transition: .4s;
  }
  
  input:checked + .player-cardlfmutesmall {
     background: ${playerCard1Object?.lessonCard?.toggleThumbColor?.color};box-shadow:0 7px 20px 0 rgba(144, 202, 249,0.3);
  }
  
  input:focus + .player-cardlfmutesmall {
    box-shadow: 0 0 1px #2196F3;
  }
  
  input:checked + .player-cardlfmutesmall:before {
    -webkit-transform: translateX(40px);
    -ms-transform: translateX(40px);
    transform: translateX(40px);
  }
  
  /* Rounded player-cardlfmutesmalls */
  .player-cardlfmutesmall.round {
    border-radius: 34px;
  }
  
  .player-cardlfmutesmall.round:before {
    border-radius: 50%;
  }
  
  .mutetitle{ position:relative; padding:5px;font-size:18px;top:-7px; font-weight:bold; }
  
  


    `}</style>
    </>)
}
export default PlayerSideBar;
